<template>
  <div class="contents8">
    <img class="bg" :src="bgImg" />
    <div class="contents">
      <div class="text1">
        카랑의 서비스
        <div class="icon" v-if="!isMobile">
          <a @click="prevBtn()"><img src="static/img/arrow_left.png"/></a>
          <a @click="nextBtn()"><img src="static/img/arrow_right.png"/></a>
        </div>
      </div>
      <div id="card-wrap" class="card-wrap">
        <div class="card" v-for="(item, index) in contents" :key="index" :id="'card' + (index + 1)" @click="getItem(index + 1)">
          <div class="img">
            <img :src="brandImg + (index + 1) + '.png'" width="100%" height="100%" />
          </div>
          <div class="card-body">
            <img :src="textImg + (index + 1) + '.png'" width="100%" height="100%" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      contents: [
        {
          title: '출장서비스',
          subText: '엔진오일 & 배터리 교 서비스'
        },
        {
          title: '외장수리 비교견적',
          subText: '사진 2장으로 OK! 무료 견적 문의!'
        },
        {
          title: '타이어',
          subText: '타이어 교체도 카수리에서 간편하게!'
        },
        {
          title: 'B2B 스마트 정비',
          subText: '카수리만의 스마트 차량 관제 플랫폼'
        }
      ],
      bgImg: 'static/img/main-content/contents8.png',
      brandImg: 'static/img/site_sub_brand_0',
      textImg: 'static/img/text',
      isMobile: false
    }
  },
  mounted() {
    window.addEventListener('resize', this.resize)
    this.resize()
  },
  methods: {
    resize() {
      if (window.innerWidth > 640) {
        this.bgImg = 'static/img/main-content/contents8.png'
        this.brandImg = 'static/img/site_sub_brand_0'
        this.textImg = 'static/img/text'
        this.isMobile = false
      } else {
        this.bgImg = 'static/img/mobile/main-content/contents8.png'
        this.brandImg = 'static/img/mobile/main-content/site_sub_brand_0'
        this.textImg = 'static/img/mobile/main-content/text'
        this.isMobile = true
      }
    },
    prevBtn() {
      document.getElementById('card-wrap').scrollLeft -= 100
    },
    nextBtn() {
      document.getElementById('card-wrap').scrollLeft += 100
    },
    getItem(index) {
      var elmnt = document.getElementById('card' + index)
      elmnt.scrollIntoView()

      if (index === 1) {
        window.open('https://www.carsuri.co.kr/reservation/')
      } else if (index === 2) {
        window.open('https://www.carsuri.co.kr/')
      } else if (index === 3) {
        window.open('https://www.carsuri.co.kr/')
      } else if (index === 4) {
        window.open('https://www.carsuri.co.kr/contact?tab=corporate-vehicle')
      }
    }
  }
}
</script>

<style scoped>
.contents8 {
  width: 100%;
  position: relative;
}
.contents8 .bg {
  width: 100%;
  height: auto;
  display: block;
}

.icon {
  float: right;
  cursor: pointer;
}
/* 스크롤 */
/* ::-webkit-scrollbar {
	width: 8px;
	height: 8px;
	border: 3px solid #fff;
}
::-webkit-scrollbar-button:start:decrement,
::-webkit-scrollbar-button:end:increment {
	display: none;
}
::-webkit-scrollbar-track {
	background: #efefef;
	-webkit-border-radius: 10px;
	border-radius: 10px;
	-webkit-box-shadow: inset 0 0 4px rgba(0, 0, 0, 0.2);
}
::-webkit-scrollbar-thumb {
	height: 50px;
	width: 50px;
	background: rgba(0, 0, 0, 0.2);
	-webkit-border-radius: 8px;
	border-radius: 8px;
	-webkit-box-shadow: inset 0 0 4px rgba(0, 0, 0, 0.1);
} */
/* -- */

/* pc */
@media (max-width: 1280px) {
  .text1 {
    font-style: normal;
    font-weight: 300;
    font-size: 38px;
    line-height: 42px;
    color: #000000;
    margin-bottom: 5%;
  }
  .icon img {
    width: 40px;
    height: auto;
  }
}
@media (min-width: 1280px) {
  .text1 {
    font-style: normal;
    font-weight: 300;
    font-size: 3vw;
    line-height: 3.7vw;
    color: #000000;
    margin-bottom: 5%;
  }
  .icon img {
    width: 3.1vw;
    height: auto;
  }
}
@media (min-width: 641px) {
  .contents8 .contents {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    padding: 5% 10% 5% 10%;
  }
  .card-wrap {
    width: 100%;
    max-width: 100%;
    height: 65%;
    overflow-x: auto;
    white-space: nowrap;
    /* scroll-behavior: smooth; */
  }
  .card-wrap .card {
    width: 23%;
    height: 95%;
    margin-right: 3%;
    display: inline-block;
    border-radius: 10px;
    cursor: pointer;
  }
  .card-wrap .card .img {
    width: 100%;
    height: 50%;
  }
  .card-wrap .card .card-body {
    width: 100%;
    height: 50%;
    white-space: normal;
  }
}
/* mobile */
@media (max-width: 640px) {
  .contents8 .contents {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    text-align: center;
  }
  .text1 {
    margin-top: 20%;

    font-style: normal;
    font-weight: 300;
    font-size: 6.4vw;
    line-height: 10vw;
    color: #000000;
    margin-bottom: 15%;
  }
  .card-wrap {
    width: 100%;
    max-width: 100%;
    height: 100%;
  }
  .card-wrap .card {
    width: 40%;
    height: 30%;
    display: inline-block;
    border-radius: 10px;
    cursor: pointer;
    margin: 0 2.5% 4%;
  }
  .card-wrap .card .img {
    width: 100%;
    height: 60%;
  }
  .card-wrap .card .card-body {
    width: 100%;
    height: 60%;
    white-space: normal;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/contents/main/Contents8.vue